import * as moment from 'moment';
import { Config } from '@shared/config';

export class Notification {
  data: any;
  id: number;
  is_reading: boolean;
  content: string;
  created_at: string;
  is_read: boolean;
  title: string;
  url: string;
  type: string;
  user_id: number;
  parameters: {
    user_id: number;
    badge_id: number;
    project_id: number;
    sign_project_by_name: boolean;
    display_name: string;
    name: string;
    surname: string;
    project_status: number;
  };

  constructor(data?: any) {
    Object.assign(this, data);
  }

  isReading(status) {
    this.is_reading = status;
  }

  get dateFromNow() {
    return moment(this.created_at, Config.DATE_FORMAT_BACKEND).fromNow();
  }

  isRead(status) {
    this.is_read = status;
  }
}
